<template>
  <section class="our-journey position-relative see__pad">
    <div class="pattern-layer">
      <div class="pattern-1 position-absolute" style="background-image: url('/shapes/shape-07.png')"></div>
    </div>
    <div class="pattern-layer">
      <div class="pattern-2 position-absolute" style="background-image: url('/shapes/shape-08.png')"></div>
    </div>
    <div class="pattern-layer">
      <div class="pattern-3 position-absolute" style="background-image: url('/shapes/shape-09.png')"></div>
    </div>
    <div class="pattern-layer">
      <div class="pattern-4 position-absolute" style="background-image: url('/shapes/shape-10.png')"></div>
    </div>

    <div class="header-container">
      <div class="row">
        <div class="col-lg-12">
          <div class="journey-header text-center">
            <div class="journey-section-label">
              <h4>{{ content.header.sectionLabel }}</h4>
            </div>
            <div class="journey-main-title">
              <h2>{{ content.header.mainTitle }}</h2>
            </div>
            <div class="journey-description">
              <p>{{ content.header.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="header-container">
      <div class="timeline-container">
        <div class="timeline-item" v-for="(item, index) in content.timeline" :key="index">
          <div class="timeline-year">{{ item.year }}</div>
          <div class="timeline-content">
            <h3>{{ item.title }}</h3>
            <p>{{ item.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AboutJourneyComp',
  props: {
    content: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
/* Import Google Fonts */
@import url('https://fonts.googleapis.com/css2?family=Archivo:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap');

/* Import Flaticon */
@import '@/assets/scss/Flaticon.scss';

.see__pad {
  padding: 100px 0;
}

.header-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}

/* Pattern Layers */
.pattern-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.pattern-1 {
  top: 10%;
  right: 5%;
  width: 100px;
  height: 100px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.1;
}

.pattern-2 {
  bottom: 20%;
  left: 8%;
  width: 80px;
  height: 80px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.08;
}

.pattern-3 {
  top: 30%;
  left: 10%;
  width: 120px;
  height: 120px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.1;
}

.pattern-4 {
  top: 15%;
  right: 15%;
  width: 90px;
  height: 90px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.08;
}

/* Journey Section */
.our-journey {
  background: #00061A;
  position: relative;
  overflow: hidden;
}

.journey-header {
  position: relative;
  z-index: 2;
  margin-bottom: 60px;
}

.journey-section-label h4 {
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 13.2px;
  color: #F6EC4F;
  margin-bottom: 20px;
  font-family: 'Archivo', sans-serif;
  text-transform: uppercase;
}

.journey-main-title h2 {
  font-size: 48px;
  font-weight: 700;
  line-height: 58px;
  color: #fff;
  margin-bottom: 20px;
  font-family: 'Archivo', sans-serif;
}

.journey-description p {
  font-size: 18px;
  color: #fff;
  max-width: 800px;
  margin: 0 auto;
  line-height: 1.8;
}

.timeline-container {
  position: relative;
  max-width: 800px;
  margin: 0 auto;
  z-index: 1;
}

.timeline-item {
  display: flex;
  align-items: center;
  margin-bottom: 40px;
  position: relative;
  z-index: 1;
}

.timeline-item:not(:last-child)::after {
  content: '';
  position: absolute;
  left: 50%;
  top: 100%;
  width: 2px;
  height: 40px;
  background: linear-gradient(to bottom, #F6EC4F, #E6D43A);
  transform: translateX(-50%);
  z-index: 1;
}

.timeline-item:nth-child(odd) {
  flex-direction: row;
}

.timeline-item:nth-child(even) {
  flex-direction: row-reverse;
}

.timeline-year {
  background: linear-gradient(135deg, #F6EC4F, #E6D43A);
  color: #00061A;
  padding: 10px 20px;
  border-radius: 25px;
  font-weight: 700;
  font-size: 16px;
  font-family: 'Archivo', sans-serif;
  min-width: 80px;
  text-align: center;
  position: relative;
  z-index: 2;
  border: 3px solid #00061A;
  box-shadow: 0 0 0 2px #F6EC4F;
}

.timeline-content {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(246, 236, 79, 0.1);
  border-radius: 15px;
  padding: 25px;
  margin: 0 30px;
  flex: 1;
  position: relative;
  z-index: 1;
}

.timeline-content h3 {
  font-size: 18px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 10px;
  font-family: 'Archivo', sans-serif;
}

.timeline-content p {
  font-size: 14px;
  color: #fff;
  line-height: 1.6;
  margin: 0;
}

/* Responsive Design */
@media only screen and (max-width: 991px) {
  .our-journey {
    padding: 80px 0;
  }
}

@media only screen and (max-width: 767px) {
  .our-journey {
    padding: 60px 0;
  }
  
  .journey-main-title h2 {
    font-size: 36px;
    line-height: 46px;
  }
  
  .journey-section-label h4 {
    letter-spacing: 8px;
    font-size: 16px;
  }
  
  .timeline-item {
    flex-direction: column !important;
    align-items: flex-start;
    padding-left: 50px;
  }
  
  .timeline-year {
    margin-bottom: 15px;
  }
  
  .timeline-content {
    margin: 0;
  }
}

@media only screen and (max-width: 399px) {
  .our-journey {
    padding: 40px 0;
  }
  
  .journey-main-title h2 {
    font-size: 28px;
    line-height: 38px;
  }
}
</style>
